import { useRouter } from 'next/router'
import styled from 'styled-components'
import ExamContainedButton from '@app.feature/exam/components/Button/ExamContainedButton'
import PredictionButton from '@app.feature/exam/gsat2024-2/components/button/PredictionButton.mobile'
import GraphIcon from 'svgIcons/GraphIcon'
import TentativeScoringDetailInfoMobile from './TentativeScoringDetailInfo.mobile'

interface TentativeScoringResultInfoMobileProps {
  onChangeStage: () => void
}

const TentativeScoringResultInfoMobile = ({
  onChangeStage,
}: TentativeScoringResultInfoMobileProps) => {
  const router = useRouter()
  const isGsat2024Route = router.pathname === '/prediction/gsat2024-2'

  const handleChangeStage = () => {
    onChangeStage()
  }

  return (
    <StyledWrapper>
      <div className="tentative-score-box">
        <TentativeScoringDetailInfoMobile />
      </div>

      {isGsat2024Route ? (
        <PredictionButton
          className="get-data-button"
          type="button"
          onClick={handleChangeStage}
        >
          석차분석 및 합격예측 리포트 받아보기
        </PredictionButton>
      ) : (
        <ExamContainedButton
          className="get-data-button"
          type="button"
          onClick={handleChangeStage}
          isEndIcon={false}
        >
          <i>
            <GraphIcon />
          </i>
          석차분석 및 합격예측 리포트 받아보기
        </ExamContainedButton>
      )}
    </StyledWrapper>
  )
}

export default TentativeScoringResultInfoMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  padding: 0px 20px;
  margin-bottom: 24px;

  > .tentative-score-box {
    width: 100%;
    display: flex;
    padding: 24px;
    border-radius: 20px;
    border: solid 1px #e8e8e8;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }

  > .get-data-button {
    width: 100%;

    i {
      > svg {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
`
